import React from 'react';
import type { HoldingsDataProps } from '../../types';
import { DATA_TYPE_EXCEL_STYLES } from '../../logic/customBlockUtils';
import ExportableGrid from './ExportableGrid';
import useHoldingsDataGrid from '../../logic/useHoldingsGridData';
import { useCommonGridProps } from '../../logic/columnUtils';
import { useIsBlockGridCompact } from '../../logic/useIsBlockGridCompact';
import { useBlockMeasureHeight } from '../../../blocks/components/core/block-measure';
import { useSetRecoilState } from 'recoil';
import { recoilBlockContentSize } from 'venn-state';

const HoldingsDataGrid = ({ selectedRefId, ...exportProps }: HoldingsDataProps) => {
  const { rowData, columnDefs, pinnedTopRowData } = useHoldingsDataGrid({ selectedRefId });

  const sharedProps = useCommonGridProps();
  const isCompact = useIsBlockGridCompact();

  const setBlockContentSize = useSetRecoilState(recoilBlockContentSize.transformedState(selectedRefId));
  const measuredHeight = useBlockMeasureHeight();

  /**
   * Updates the block content size when resize in grid is triggered.
   * Uses width from ag‑Grid (sum of all columns) and prefers height from BlockMeasureContext.
   *
   * @param _height Height reported by the grid.
   * @param width   Width reported by the grid (sum of all columns).
   */
  const handleGridSizeChange = (_height: number, width: number) => {
    const height = measuredHeight ?? _height;
    setBlockContentSize({ width, height });
  };

  return (
    <div>
      <ExportableGrid
        {...sharedProps}
        {...exportProps}
        exportable={false} // TODO VENN-21564 - make this exportable
        rowData={rowData}
        pinnedTopRowData={pinnedTopRowData}
        selectedRefId={selectedRefId}
        columnDefs={columnDefs}
        excelStyles={DATA_TYPE_EXCEL_STYLES}
        isCompact={isCompact}
        onGridSizeChange={handleGridSizeChange}
      />
    </div>
  );
};

export default HoldingsDataGrid;
